<template>
  <div>
    <!--    <vue-headful :title="title"/>-->
    <!-- Nav Bar -->
    <!-- <nav-component
      :showPublish="website.status === 'inactive'"
      :showUnpublish="website.status === 'active'"
      :showRepublish="showRepublish"
      :website="website"
      :sidebarMini="sidebarMini"
      @publish="publish"
      @republish="republish"
      @changeStatusPublish="changeStatusPublish"
      @toggleSidebarMini="toggleSidebarMini"
      :sidebarMobile="sidebarMobile"
      @toggleSidebarMobile="toggleSidebarMobile"
    ></nav-component> -->

    <!-- Tour -->
    <div data-v-tour="init"></div>

    <div>
      <!-- SideBar -->
      <!-- <site-sidebar-component
        :website="website"
        :sidebarMini="sidebarMini"
        :sidebarMobile="sidebarMobile"
        @toggleSidebarMobile="toggleSidebarMobile"
      ></site-sidebar-component> -->

      <!-- Website Main -->
      <div class="ba-container ba-grid ba-gp-1 ba-ai-baseline">
        <Breadcrumbs />
        <div v-if="Object.keys(website).length" class="ba-w-100">
          <transition name="slide-left">
            <router-view
              :showRepublish="showRepublish"
              @publish="publish"
              @republish="republish"
              @changeStatusPublish="changeStatusPublish"></router-view>
          </transition>
        </div>

        <!-- <div
          class="container d-flex justify-content-center align-items-center"
          style="height: 250px"
          v-else
        >
          <div
            class="spinner-border"
            style="width: 3rem; height: 3rem"
            role="status"
          >
            <span class="sr-only">Loading...</span>
          </div>
        </div> -->
      </div>

      <!-- <div
        class="screen-overlay d-md-none"
        :class="{ show: sidebarMobile }"
        @click="toggleSidebarMobile"
      ></div> -->
    </div>

    <site-publish-component
      ref="publish-modal"
      :website="website"
      :show="modalDelete.publish.show"
      @openSaveTour="openSaveTour"
      @cancel="cancelModal('domain')"
    ></site-publish-component>

    <modal-initial-component
      :show="modalInitial.show"
      :site_id="website.encrypted_id"
      @closeInitial="closeInitialModal"
    ></modal-initial-component>

    <template v-if="website && website.layouts && website.layouts.length > 0">
      <save-website-component
        :id_layout="website.layouts[0].encrypted_id"
        :id_website="website.encrypted_id"
        :type="modalDelete.saveTour.type"
        :show="modalDelete.saveTour.show"
        @closeAction="cancelModal('saveTour')"
      ></save-website-component>
    </template>
    <vue-progress-bar></vue-progress-bar>
    <v-tour
      ref="tours"
      name="dashTour"
      :steps="steps"
      :options="stepsOptions"
      :class="'v-step-' + tour.currentStep"
    ></v-tour>
  </div>
</template>

<script>
import NavComponent from "./layout/nav/Nav.vue";
import SitePublishComponent from "./layout/site/SitePublish";
import SiteSidebarComponent from "./layout/site/SiteSidebar";
import BreadcrumbComponent from "./components/Breadcrumb";
import ModalDeleteComponent from "./components/ModalDelete";
import SaveWebsiteComponent from "./components/SaveWebsiteComponent";
import ModalInitialComponent from "../dashboard/components/ModalInitial";
import { SweetModal } from "sweet-modal-vue";
import Breadcrumbs from "../general/Breadcrumbs.vue";
import { getLanguages } from "../../js/services/translate";
import { get as getWebsite } from "../../js/services/editor/website";

import { mapGetters } from "vuex";
import { updateVersion } from "../../js/services/editor/publish";

export default {
  name: "Site",
  components: {
    NavComponent,
    BreadcrumbComponent,
    ModalDeleteComponent,
    SiteSidebarComponent,
    SweetModal,
    SaveWebsiteComponent,
    SitePublishComponent,
    ModalInitialComponent,
    Breadcrumbs
  },
  data() {
    return {
      showRepublish: true,
      title: "",
      sidebarMini: false,
      sidebarMobile: false,

      steps: [
        {
          target: "[data-v-tour=init]", // We're using document.querySelector() under the hood
          content: this.$t("ct-joyride-dashboard-0"),
        },
        {
          target: "#pages", // We're using document.querySelector() under the hood
          content: this.$t("ct-joyride-dashboard-1"),
        },
        {
          target: ".box.new-page", // We're using document.querySelector() under the hood
          content: this.$t("ct-joyride-dashboard-2"),
          params: {
            placement: "bottom",
          },
        },
        {
          target: ".btn-editor", // We're using document.querySelector() under the hood
          content: this.$t("ct-joyride-dashboard-3"),
          params: {
            placement: "bottom",
          },
        },
        {
          target: ".options-page", // We're using document.querySelector() under the hood
          content: this.$t("ct-joyride-dashboard-4"),
          params: {
            placement: "bottom",
          },
        },
        {
          target: ".list-group-flush", // We're using document.querySelector() under the hood
          content: this.$t("ct-joyride-dashboard-5"),
          params: {
            placement: "right",
          },
        },
        {
          target: ".tour-3", // We're using document.querySelector() under the hood
          content: this.$t("ct-joyride-dashboard-6"),
          params: {
            placement: "bottom",
          },
        },
        {
          target: ".publish-button", // We're using document.querySelector() under the hood
          content: this.$t("ct-joyride-dashboard-7"),
          params: {
            placement: "bottom",
          },
        },
      ],
      stepsOptions: {
        useKeyboardNavigation: false,
        highlight: true,
        labels: {
          buttonSkip: this.$t("ct-joyride-skip-tour"),
          buttonPrevious: this.$t("ct-joyride-previous"),
          buttonNext: this.$t("ct-joyride-next"),
          buttonStop: this.$t("ct-joyride-finish"),
        },
      },
      offsetScroll: 0,
      tour: {
        currentStep: 0,
      },

      website: {},
      modalDelete: {
        publish: {
          show: false,
          config: false,
        },
        saveTour: {
          show: false,
          config: false,
          type: "save",
        },
      },
      modalInitial: {
        show: 0,
      },
    };
  },
  computed: {
    websiteCurrent() {
      return this.$store.getters.website;
    },
  },

  watch: {
    websiteCurrent: {
      handler: function (val, oldVal) {
        if (!Object.keys(val).length) {
          this.fetchData();
        } else {
          this.website = val;
        }
      },
      deep: true,
    },

    website: function (website) {
      // if (Object.keys(website).length) { this.setTitlePage(this.$route) }
    },

    $route: function (route) {
      // this.setTitlePage(route);
    },
  },

  methods: {
    ...mapGetters({ getUser: "user" }),

    toggleSidebarMini() {
      this.sidebarMini = !this.sidebarMini; // icon
      localStorage.setItem("siteSidebarMini", this.sidebarMini); // persist
    },

    toggleSidebarMobile(forceStatus = false, status = false) {
      this.sidebarMobile = !this.sidebarMobile; // icon

      $("body").toggleClass("offcanvas-active");
    },

    setTitlePage(route) {
      if (
        route &&
        route.meta &&
        route.meta.breadcrumb &&
        route.meta.breadcrumb.length
      ) {
        let activeBread = route.meta.breadcrumb.find(
          (bread) =>
            bread.active &&
            !["my-site", "website", "site"].includes(bread.title)
        );
        let siteBread = route.meta.breadcrumb.find(
          (bread) =>
            bread.title && ["my-site", "website", "site"].includes(bread.title)
        );

        this.title = "Cheetah";

        if (activeBread) {
          this.title += ` | ${this.$t(`ct-${activeBread.title}`)}`;
        }

        if (siteBread && this.website.title) {
          this.title += (activeBread ? " - " : " | ") + this.website.title;
        }
      }
    },

    cancelModal(type) {
      this.modalDelete[type].show = false;
      this.modalDelete[type].config = "";
    },

    openSaveTour() {
      let website = this.website;

      this.modalDelete.saveTour.show = 1;
      this.website = Object.assign({}, website, {
        status: "active",
      });

      this.$store.commit("website", this.website);
    },

    changeStatusPublish(status) {
      this.website.status = status;
    },

    getWebsiteEncryptedIdCurrent() {
      if (this.website.encrypted_id) {
        return this.website.encrypted_id;
      }
      return false;
    },

    publish() {
      this.$refs["publish-modal"].open();
    },

    republish() {
      this.showRepublish = false;

      const info = this.$snotify.info(
        `${this.$t("ct-republishing")}...`, 
        '', 
        {
          timeout: 9999999999,
          showProgressBar: false
        }
      );

      if (this.getWebsiteEncryptedIdCurrent()) {
        updateVersion(this.getWebsiteEncryptedIdCurrent())
          .then((res) => {
            this.$snotify.success(this.$t("ct-republished"));
          })
          .catch((error) => {
            if (error.response) {
              // Request made and server responded
              if (error.response.status === 429) {
                // to many
                this.$snotify.error(this.$t("ct-too-many-attempts"));
              }
              if (error.response.status === 401) {
                const message = (error.response && error.response.data && error.response.data.message) ? error.response.data.message : 'ct-plan-limited'
                // to many
                this.$snotify.error(this.$t(message));
                setTimeout(() => {
                  this.$router.push({
                    name: "Domain",
                    params: {
                      id: this.getWebsiteEncryptedIdCurrent(),
                    },
                  });
                }, 2000);
              }
            }
          })
          .finally(() => {
            this.showRepublish = true
            this.$snotify.remove(info.id)
          });
      }

      if (!this.website.layouts[0].pages.find((page) => page.initial))
        this.openInitialModal();
    },

    updateData() {
      getWebsite(this.website.encrypted_id)
        .then((data) => {
          this.website = data.data;
        })
        .catch((error) => console.warn(error));
    },

    fetchData() {
      this.$loading.show();

      this.$store.commit("website", false);

      getWebsite(this.$route.params.id || this.$route.params.website_id)
        .then((res) => {
          this.$store.commit("website", res.data);
        })
        .catch((error) => {
          this.$router.push({
            name: "Dashboard",
          });
        })
        .finally(() => {
          setTimeout(() => {
            this.$loading.hide();
          }, 2000);
        });
    },

    sidebarInit() {
      let localStorageMini = localStorage.getItem("siteSidebarMini");
      if (typeof localStorageMini !== "undefined") {
        this.sidebarMini = JSON.parse(localStorageMini);
      }
    },

    openInitialModal() {
      this.modalInitial.show = 1;
    },

    closeInitialModal() {
      this.modalInitial.show = 0;
    },
  },

  created() {
    var vm = this;

    this.$router.beforeResolve((to, from, next) => {
      if (to.name) {
        window.vm.$Progress.start();
      }
      next();
    });

    this.$router.afterEach((to, from) => {
      //  finish the progress bar
      /*
       * Force scroll for edit pages
       * */
      $("html").animate(
        {
          scrollTop: 0,
        },
        500
      );

      if (vm.sidebarMobile) {
        this.toggleSidebarMobile();
      }
    });

    this.sidebarInit();
    this.fetchData();
  },

  mounted() {
    getLanguages()
        .then(data => {
          if(data) {
            this.$store.commit('languages', data.data);
          }
        })
        .catch(error => {
          console.warn(error);
        });
    if (this.$route.query.tour) {
      let tourcfb = window.getCookie("tour-cfb-dashboard");

      if (!tourcfb) {
        window.setCookie("tour-cfb-dashboard", "loaded");

        let vm = this;

        setTimeout(() => {
          vm.$tours["dashTour"].start();
          vm.tour = vm.$tours["dashTour"];
        }, 5000);
      }
    }
  },
};
</script>

<style lang="scss">
.turbo-bg {
  background: #6563ff1a;
}

.container-dashboard {
  padding-bottom: 100px;
}

.v-tour__target--highlighted {
  box-shadow: 0 0 0 99999px rgba(0, 0, 0, 0.4);
}

.dashboard-wrapper {
  .v-step-0 {
    .v-step {
      position: absolute;
      top: 35% !important;
      left: 50% !important;
      transform: none !important;
      box-shadow: 0 0 0 99999px rgba(0, 0, 0, 0.4);
    }

    .v-step__arrow {
      display: none;
    }
  }
}

.website-main {
  .slide-left-enter-active,
  .slide-left-leave-active {
    transition-duration: 0.5s;
    transition-property: height, opacity, transform;
    transition-timing-function: cubic-bezier(0.55, 0, 0.1, 1);
    transform: translate(0, 0);
    overflow: hidden;
  }

  .slide-left-enter {
    opacity: 0;
    transform: translate(0.5em, 0);
  }

  .slide-left-leave-active {
    opacity: 0;
    transform: translate(-0.5em, 0);
  }
}

.screen-overlay {
  width: 0%;
  height: 100%;
  z-index: 30;
  position: fixed;
  top: 0;
  left: 0;
  opacity: 0;
  visibility: hidden;
  background-color: rgba(34, 34, 34, 0.6);
  transition: opacity 0.2s linear, visibility 0.1s, width 1s ease-in;
}

.screen-overlay.show {
  transition: opacity 0.5s ease, width 0s;
  opacity: 1;
  width: 100%;
  visibility: visible;
}
</style>

<style lang="scss" scoped>
html {
  overflow: hidden;
}

.dashboard-wrapper {
  min-width: 300px;
}

.website-wrapper {
  display: grid;

  grid-template-columns: 1fr;

  @media (min-width: 768px) {
    &.sidebar-mini-active {
      grid-template-columns: 66px auto;
    }

    grid-template-columns: 230px auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/Site.vue